function NotFound() {
  throw new Error('Not Found')
}

export default NotFound
